import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import { api } from "@/lib/api";
import { fmtOdds, money, SPORT_META } from "@/lib/odds";

export function ResultsTicker() {
  const [d, setD] = useState(null);
  const [flash, setFlash] = useState(false);
  useEffect(() => {
    let prev = null;
    const load = () => api.get("/results/live").then((r) => {
      if (prev !== null && r.data.today.settled !== prev) { setFlash(true); setTimeout(() => setFlash(false), 1500); }
      prev = r.data.today.settled;
      setD(r.data);
    }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const { today, items, my_recent } = d;
  const doubled = items.length ? [...items, ...items] : [];

  return (
    <section data-testid="results-ticker" className={`glass-card overflow-hidden transition-[box-shadow] duration-500 ${flash ? "glow-green" : ""}`}>
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-[#26334D] px-5 py-3">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-emerald-400"><Radio size={14} className="pulse-dot rounded-full" /> Live results</span>
        <Stat id="ticker-live" label="In play" value={today.live} color="text-cyan-300" />
        <Stat id="ticker-upcoming" label="Upcoming" value={today.upcoming} color="text-slate-200" />
        <Stat id="ticker-settled" label="Settled" value={`${today.settled}/${today.total}`} color="text-white" />
        <Stat id="ticker-record" label="Model record" value={`${today.won}–${today.lost}`} color={today.won >= today.lost ? "text-emerald-400" : "text-red-400"} />
        {my_recent.length > 0 && (
          <Link to="/parlays" data-testid="ticker-my-recent" className="ml-auto text-xs text-slate-400 hover:text-white">
            Your latest: <span className={`font-bold ${my_recent[0].status === "won" ? "text-emerald-400" : "text-red-400"}`}>{my_recent[0].title} {my_recent[0].status.toUpperCase()} {my_recent[0].profit >= 0 ? "+" : ""}{money(my_recent[0].profit)}</span>
          </Link>
        )}
      </div>
      {doubled.length ? (
        <div className="overflow-hidden py-2.5">
          <div className="ticker-track flex w-max gap-8" data-testid="ticker-items">
            {doubled.map((p, i) => (
              <span key={`${p.pick_id}-${i}`} data-testid={i < items.length ? "ticker-item" : undefined} className="flex items-center gap-2 whitespace-nowrap text-sm">
                <span className={`rounded px-1.5 py-0.5 text-[10px] font-black uppercase ${p.result === "won" ? "bg-emerald-500/20 text-emerald-300" : "bg-red-500/20 text-red-300"}`}>{p.result === "won" ? "W" : "L"}</span>
                <span className="h-1.5 w-1.5 rounded-full" style={{ background: SPORT_META[p.sport]?.color }} />
                <span className="text-slate-500">{p.matchup}</span>
                <span className="font-semibold text-white">{p.selection}</span>
                <span className="font-mono-num text-amber-400">{fmtOdds(p.odds)}</span>
              </span>
            ))}
          </div>
        </div>
      ) : (
        <p className="px-5 py-3 text-xs text-slate-500" data-testid="ticker-empty">No results yet — games settle automatically about three hours after tip-off.</p>
      )}
    </section>
  );
}

function Stat({ id, label, value, color }) {
  return <span className="text-xs text-slate-500">{label} <span data-testid={id} className={`font-mono-num font-bold ${color}`}>{value}</span></span>;
}
